import AddReviewContent from "../components/reviews/AddReviewContent";

export default function AddReview() {
  return (
    <>
      <AddReviewContent />
    </>
  );
}